import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputCheckboxAttr = makeAttrStruct([
    ['name'],
    ['value'],
    ['class'],
    ['checked', false],
    ['type', HTTPINPUTTYPE.CHECKBOX]
]);
export const inputCheckboxData = makeDataStruct([]);
export const inputCheckboxModel = makeStruct([
    ['attributes', inputCheckboxAttr],
    ['data', inputCheckboxData]
]);
// Simplified Model
export function inputCheckbox(name, value, className, checked) {
    return {
        attributes: inputCheckboxAttr(name, value, className, checked),
        data: inputCheckboxData()
    };
}
// Class
export default class INPUTCHECKBOX extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
    /** Override getValue to only return value if checkbox is checked */
    getValue() {
        return this.el.checked ? this.el.value : null;
    }
    activate(event) {
        console.log('INPUTCHECKBOX.activate()', event);
    }
    deactivate(event) {
        console.log('INPUTCHECKBOX.deactivate()', event);
    }
}
